// extracted by mini-css-extract-plugin
export default {"icon":"sPyE4u","oldIcon":"tz5HXJ","circle":"DU9Xpw","emptyLink":"mBUY7E"};